module.exports = __webpack_public_path__ + "assets/a3508b73350e730c34cc4f4ae9bfdc4a.png";